<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * Starter page component
 */
export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "Starter page",
      items: [
        {
          text: "Utility",
          href: "/",
        },
        {
          text: "Starter page",
          active: true,
        },
      ],

      ismobile: false,
      activeNames: [],
      activeapp: [],
      showmodel: "1",
      userinfo: [],
      admininfo: {
        username: "",
        phone: "",
        country: 86,
      },
      wristbandsetting: {
        active: false,
        device: ["all"],
        check_device: false,
        price: "",
        maxprice: "",
        maxvalue: "",
        timerange: [],
      },
      drinkFieldEnabled: {
        price: false,
        maxprice: false,
        maxvalue: false,
        timerange: true,
      },
      userpassword: "",
      reinputuserpassword: "",
      loading: true,
      adminid: 0,
      showsuccess: false,
      countrylist: [],
      systemtype: 0,
      card: "",
      type: true,
      wristbandconfig: [],
      cashiersetting: true,
      tablesdata: [],
      cashierconfig: [],
      cashiertable_hll: [],
      cashiertable: [],
      cashierstatus: false,
      devicelist: [],
      isAllSelected: false,
      group_mode: false,
      group: []
    };
  },
  mounted() {
    var that = this;
    that.wristbandsetting.timerange = that.getDefaultDrinkTimeRange();
    that.title = that.$t("menuitems.user.add");
    that.items = [
      {
        text: that.$t("menuitems.user.text"),
        href: "/",
      },
      {
        text: that.$t("menuitems.user.add"),
        active: true,
      },
    ];

    that.userinfo = JSON.parse(localStorage.getItem("user"));
    let flag = navigator.userAgent.match(
      /(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      // that.ismobile = true;
    }
    that.countrylist = [
      {
        value: 86,
        label: that.$t("global.country.china"),
      },
      {
        value: 1,
        label: that.$t("global.country.usa"),
      },
      {
        value: 81,
        label: that.$t("global.country.japan"),
      },
      {
        value: 44,
        label: that.$t("global.country.uk"),
      },
      {
        value: 34,
        label: that.$t("global.country.spain"),
      },
      {
        value: 33,
        label: that.$t("global.country.french"),
      },
      {
        value: 60,
        label: that.$t("global.country.malaysia"),
      },
      {
        value: 65,
        label: that.$t("global.country.singapore"),
      },
      {
        value: 84,
        label: that.$t("global.country.vietnam")
      },
      {
        value: 66,
        label: that.$t("global.country.thailand")
      },
      {
        value: 91,
        label: that.$t("global.country.india")
      }
    ];
    that.getsysteminfo();
    that.getcashierconfig();
    that.card = that.$route.query.id;
    var numReg = /^[0-9]*$/;
    var numRe = new RegExp(numReg);
    if (!numRe.test(that.card) || that.card.length == 8) {
      that.type = false;
      that.loading = false;
      that.getwristbandsetting();
    } else {
      that.adminid = that.$route.query.id;
      that.getgadmindetail();
    }
    that.getdevicelist();
    that.getGroup();
  },
  methods: {
    getDefaultDrinkTimeRange() {
      const start = new Date();
      const end = new Date(start.getTime() + 2 * 60 * 60 * 1000);
      return [start, end];
    },
    buildDrinkWristbandPayload() {
      const payload = {
        active: this.wristbandsetting.active,
        device: this.wristbandsetting.device,
        check_device: this.wristbandsetting.check_device,
      };
      if (!this.wristbandsetting.active) {
        return payload;
      }

      if (this.drinkFieldEnabled.price && this.wristbandsetting.price !== "") {
        payload.price = this.wristbandsetting.price;
      }
      if (this.drinkFieldEnabled.maxprice && this.wristbandsetting.maxprice !== "") {
        payload.maxprice = this.wristbandsetting.maxprice;
      }
      if (this.drinkFieldEnabled.maxvalue && this.wristbandsetting.maxvalue !== "") {
        payload.maxvalue = this.wristbandsetting.maxvalue;
      }
      if (
        this.drinkFieldEnabled.timerange &&
        Array.isArray(this.wristbandsetting.timerange) &&
        this.wristbandsetting.timerange.length === 2
      ) {
        payload.timerange = this.wristbandsetting.timerange;
      }

      return payload;
    },
    getGroup() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getgroup",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          if (response.data.status === 200) {
            that.group = response.data.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getsysteminfo() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "systeminfo",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.systemtype = parseInt(response.data.data.model);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getgadmindetail() {
      var that = this;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getuserinfo",
            id: that.adminid,
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          let newdata = response.data.data;
          that.admininfo = {
            username: newdata.username,
            phone: newdata.phone,
            country: newdata.country,
          };
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    addadminuser() {
      var that = this;
      if (!that.admininfo.username) {
        that.$message.error(that.$t("admin.add.usernotintut"));
        return;
      }
      if (that.admininfo.username < 4) {
        that.$message.error(that.$t("admin.add.userlong"));
        return;
      }
      if (!that.admininfo.phone) {
        that.$message.error(that.$t("admin.add.phonenotintut"));
        return;
      }
      if (that.admininfo.phone < 11) {
        that.$message.error(that.$t("admin.add.phonelong"));
        return;
      }
      let postdata = {
        action: "addnewuser",
        id: that.adminid,
        phone: that.admininfo.phone,
        country: that.admininfo.country,
        username: that.admininfo.username,
        password: that.reinputuserpassword,
        hex: that.card,
      };
      // console.log(that.card);
      that.$axios
        .post(that.apiuri, postdata, {
          headers: { Openid: that.userinfo.openid },
        })
        .then(function (response) {
          that.$toast.clear();
          if (response.data.status == 200) {
            that.showsuccess = true;
          } else {
            if (response.data.msg) {
              that.$message.error(
                that.$t("user.add.error." + response.data.msg)
              );
            } else {
              that.$message.error(that.$t("global.delete.500"));
            }
          }
        })
        .catch(function (error) {
          $t("user.add.error.havenopayorder");
          console.log(error);
        });
    },
    addwhitelist() {
      var that = this;
      const drinkWristbandPayload = that.buildDrinkWristbandPayload();
      if (!that.admininfo.username) {
        that.$message.error(that.$t("admin.add.usernotintut"));
        return;
      }
      let postdata = {};
      if (that.admininfo.phone) {
        postdata = {
          action: "addwhitelist",
          id: that.card,
          user: that.admininfo.username,
          phone: that.admininfo.phone,
          wristband: drinkWristbandPayload,
        };
      } else if (that.admininfo.pointId) {
        let new_username
        if (that.admininfo.remark) {
          new_username = `${that.admininfo.username} - ${that.admininfo.remark}`
        } else {
          new_username = `${that.admininfo.username}`
        }
        postdata = {
          action: "addwhitelist",
          id: that.card,
          user: new_username,
          pointId: that.admininfo.pointId,
          wristband: drinkWristbandPayload,
        };
      } else {
        postdata = {
          action: "addwhitelist",
          id: that.card,
          user: that.admininfo.username,
          wristband: drinkWristbandPayload,
        };
      }
      if (postdata.id.length != 8) {
        that.$message.error(that.$t("user.add.error.cardreaderror"));
        return;
      }
      that.$axios
        .post(that.apiuri, postdata, {
          headers: { Openid: that.userinfo.openid },
        })
        .then(function (response) {
          that.$toast.clear();
          if (response.data.status == 200) {
            that.showsuccess = true;
          } else {
            if (response.data.msg) {
              that.$message.error(
                that.$t("admin.add.error." + response.data.msg)
              );
            } else {
              that.$message.error(that.$t("global.delete.500"));
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    checkinputphone(val) {
      console.log(val);
    },
    getwristbandsetting() {
      var that = this;
      that.loading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getwristbandsetting",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          that.wristbandconfig = response.data.config.maxprice
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getcashierconfig() {
      var that = this;
      that.loading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "get_cashier_config",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          if (response.data.status == 200) {
            that.cashierconfig = response.data.config
            that.cashierstatus = that.cashierconfig.status
            if (that.cashierconfig.type == "hualala") {
              that.cashiersetting = false
            }
          }

        })
        .catch(function (error) {
          console.log(error);
        });
    },
    gettablesdata() {
      var that = this;
      that.loading = true
      that.$axios
        .post(
          that.apiuri,
          {
            action: "get_" + that.cashierconfig.type + "_tables",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false
          if (response.data.msgQueueDataList) {
            that.cashiertable_hll = response.data.msgQueueDataList;
            if (that.cashiertable_hll.length == 0) {
              that.$message.error(that.$t("user.add.cashier.no_table_info"))
            }
          } else {
            that.cashiertable = response.data.list;
          }

        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getdevicelist() {
      var that = this;
      that.loading = true;
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getdevicelist",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading = false;
          that.devicelist = response.data.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleSelectChange(selected) {
      // 判断是否选中了 "all"
      if (selected.includes("all")) {
        this.isAllSelected = true;
        this.wristbandsetting.device = ["all"]; // 保证只选择 all
      } else {
        this.isAllSelected = false;

        // 判断是否手动选择了所有设备（不包括 "all"）
        const deviceIds = this.devicelist.map((device) => device.ED_id);
        const allSelected = deviceIds.every((id) => selected.includes(id));

        if (allSelected) {
          this.isAllSelected = true;
          this.wristbandsetting.device = ["all"]; // 切换到 all
        }
      }
    },
    groupmod(val) {
      if (val) {
        this.wristbandsetting.device = []
      } else {
        this.wristbandsetting.device = ["all"]
      }
    },
    handleUsernameChange(selectedName) {
      const selected = this.cashiertable.find(item => item.displayName === selectedName);
      if (selected) {
        this.admininfo.pointId = selected.id;
      } else {
        this.admininfo.pointId = null;
      }
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-loading="loading" v-if="!showsuccess">
            <form class="form-group" id="adminaddform">
              <div class="form-group"
                v-if="cashierstatus && (cashierconfig.type == 'hualala' || cashierconfig.type == 'tcsl')">
                <label for="username" style="display: block">{{
                  $t("admin.add.username")
                }}</label>

                <el-row v-if="cashiertable_hll.length > 0 && cashierconfig.type == 'hualala'">
                  <el-col :span="8">
                    <el-select v-model="admininfo.username" :placeholder="$t('global.text.select')">
                      <el-option v-for="item in cashiertable_hll" :key="item.saasOrderKey" :label="item.tableName"
                        :value="item.tableName + '|' + item.saasOrderKey">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="16">
                    <el-button type="primary" plain @click="gettablesdata">{{ $t("user.add.cashier.select_table") }}</el-button>
                  </el-col>
                </el-row>
                <el-row v-else-if="cashiertable.length > 0 && cashierconfig.type == 'tcsl'">
                  <el-col :span="4">
                    <el-select v-model="admininfo.username" :placeholder="$t('global.text.select')" @change="handleUsernameChange">
                      <el-option v-for="item in cashiertable" :key="item.id" :label="item.displayName"
                        :value="item.displayName">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4">
                    <el-input v-model="admininfo.remark" :placeholder="$t('user.add.cashier.remark_placeholder')"></el-input>
                  </el-col>
                  <el-col :span="16">
                    <el-button type="primary" plain @click="gettablesdata">{{ $t("user.add.cashier.refresh_table") }}</el-button>
                  </el-col>
                </el-row>
                <el-row v-else>
                  <el-col :span="8">
                    <input type="text" class="form-control" id="username" name="username" v-model="admininfo.username"
                      style="width: 80%; float: left" :placeholder="$t('admin.add.username')" />
                  </el-col>
                  <el-col :span="16">
                    <el-button type="primary" plain @click="gettablesdata">{{ $t("user.add.cashier.pull_table") }}</el-button>
                  </el-col>
                </el-row>

              </div>
              <div class="form-group" v-else>
                <label for="username">{{ $t("admin.add.username") }}</label>
                <input type="text" class="form-control" id="username" name="username" v-model="admininfo.username"
                  :placeholder="$t('admin.add.username')" />
              </div>
              <div class="form-group" v-if="cashierstatus && cashierconfig.type == 'tcsl' && cashiertable.length > 0">
                <label for="phone">{{ $t("user.add.cashier.point_code") }}</label>
                <input type="text" class="form-control" id="pointId" name="pointId" v-model="admininfo.pointId"
                  :placeholder="$t('user.add.cashier.point_code')" disabled />
              </div>
              <div class="form-group" v-else>
                <label for="phone">{{ $t("admin.add.phone") }}</label>
                <el-row>
                  <el-col :span="6">
                    <div class="grid-content bg-purple">
                      <el-select v-model="admininfo.country" :placeholder="$t('admin.add.selectcountry')" filterable>
                        <el-option v-for="item in countrylist" :key="item.value" :label="item.label"
                          :value="item.value">
                          <span style="float: left">{{ item.label }}</span>
                          <span>{{ item.value }}</span>
                        </el-option>
                      </el-select>
                    </div>
                  </el-col>
                  <el-col :span="18">
                    <div class="grid-content bg-purple-light">
                      <el-input :placeholder="$t('admin.add.phone')" v-model="admininfo.phone" maxlength="11">
                      </el-input>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <el-form ref="form" label-width="120px" v-if="card && cashierstatus && cashierconfig.type == 'tcsl'">
                <el-form-item :label="$t('marketing.wristband.maxprice')">
                  <el-switch v-model="wristbandsetting.active"></el-switch>
                </el-form-item>
              </el-form>
              <el-form ref="form" label-width="120px" v-if="card && wristbandconfig.active && wristbandconfig.systemtype == 1">
                <el-form-item :label="$t('marketing.wristband.maxprice')">
                  <el-switch v-model="wristbandsetting.active"></el-switch>
                </el-form-item>
                <el-form-item v-if="group.length > 0 && wristbandsetting.active" :label="$t('marketing.wristband.group_mode')">
                  <el-switch v-model="group_mode" @change="groupmod"></el-switch>
                </el-form-item>
                <el-form-item :label="$t('marketing.wristband.device')" v-if="card && wristbandconfig.active &&
                  wristbandsetting.active &&
                  !group_mode
                ">
                  <el-select v-model="wristbandsetting.device" multiple filterable
                    :placeholder="$t('global.text.select')" @change="handleSelectChange">
                    <el-option value="all" :label="$t('marketing.billing.alldevices')"></el-option>
                    <el-option v-for="item in devicelist" :key="item.ED_id" :label="item.name" :value="item.ED_id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('marketing.wristband.group')" v-if="wristbandconfig.active &&
                  wristbandsetting.active &&
                  group_mode
                ">
                  <el-select v-model="wristbandsetting.device" filterable :placeholder="$t('global.text.select')">
                    <el-option v-for="item in group" :key="item.name" :label="item.name" :value="item.devices">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item :label="$t('marketing.wristband.check_device')" v-if="wristbandconfig.active &&
                  wristbandsetting.active
                ">
                  <el-switch v-model="wristbandsetting.check_device"></el-switch>
                </el-form-item>
                <el-form-item v-if="wristbandconfig.active && wristbandsetting.active">
                  <el-row :gutter="12">
                    <el-col :span="8">
                      <el-checkbox v-model="drinkFieldEnabled.price">{{ $t('marketing.wristband.pricesingle') }}</el-checkbox>
                      <el-input v-model="wristbandsetting.price" :disabled="!drinkFieldEnabled.price"
                        :placeholder="$t('marketing.wristband.pricesingle')"></el-input>
                    </el-col>
                    <el-col :span="8">
                      <el-checkbox v-model="drinkFieldEnabled.maxprice">{{ $t('marketing.wristband.maxpricevalue') }}</el-checkbox>
                      <el-input v-model="wristbandsetting.maxprice" :disabled="!drinkFieldEnabled.maxprice"
                        :placeholder="$t('marketing.wristband.maxpricevalue')"></el-input>
                    </el-col>
                    <el-col :span="8">
                      <el-checkbox v-model="drinkFieldEnabled.maxvalue">{{ $t('marketing.wristband.maxvalues') }}</el-checkbox>
                      <el-input v-model="wristbandsetting.maxvalue" :disabled="!drinkFieldEnabled.maxvalue"
                        :placeholder="$t('marketing.wristband.maxvalues')"></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item :label="$t('marketing.wristband.time')" v-if="wristbandconfig.active && wristbandsetting.active">
                  <el-checkbox v-model="drinkFieldEnabled.timerange">{{ $t('marketing.wristband.time') }}</el-checkbox>
                  <el-date-picker v-model="wristbandsetting.timerange" type="datetimerange"
                    :disabled="!drinkFieldEnabled.timerange" :range-separator="$t('orders.v3.rangeSeparator')"
                    :start-placeholder="$t('orders.v3.startPlaceholder')" :end-placeholder="$t('orders.v3.endPlaceholder')"
                    align="right">
                  </el-date-picker>
                </el-form-item>
              </el-form>

              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <el-button type="primary" v-if="card && systemtype === 2 && !type" @click="addwhitelist">{{
                      $t("user.add.temp") }}</el-button>
                    <el-button type="primary" v-else-if="!card && systemtype === 2 && !type" disabled>{{
                      $t("user.add.temp") }}</el-button>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="grid-content bg-purple text-center">
                    <el-button
                      v-if="(cashiertable_hll.length == 0 || cashiertable.length == 0) && wristbandsetting.active == false"
                      type="success" @click="addadminuser">{{
                        $t("goods.additem.save") }}</el-button>
                    <el-button v-else type="success" disabled>{{
                      $t("goods.additem.save") }}</el-button>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content bg-purple text-right">
                    <router-link :to="{
                      path: '/user/list',
                    }">
                      <a href="javascript:;" class="btn btn-light btn-fw">{{
                        $t("global.return")
                      }}</a>
                    </router-link>
                  </div>
                </el-col>
              </el-row>
            </form>
          </div>
          <div v-else>
            <el-result icon="success" :title="$t('global.success')">
              <template slot="extra">
                <router-link :to="{
                  path: '/user/list',
                }">
                  <el-button type="primary" size="medium">{{
                    $t("global.return")
                  }}</el-button>
                </router-link>
              </template>
            </el-result>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>